import { call, put, takeLatest } from "redux-saga/effects";
import {
  bookingViewEffect,
  bookingViewAllEffect,
  fetchAllBookingsEffect,
  bookingAddEffect,
  bookingDeleteEffect,
  fetchServiceTypeEffect,
  fetchCustomerBookingsEffect,
  fetchTransitServiceTypeEffect,
  updateBookingDiscountStatusAPI,
  instantBookingAddEffect,
  instantBookingTokenEffect,
  bookingEditEffect
} from "./BookingEffect";

import {
  fetchBookingsSuccess,
  fetchBookingsFailure,
  fetchBookingSuccess,
  fetchBookingFailure,
  addBookingSuccess,
  addBookingFailure,
  deleteBookingSuccess,
  deleteBookingFailure,
  fetchServiceTypeSuccess,
  fetchServiceTypeFailure,
  fetchAllBookingsSuccess,
  fetchAllBookingsFailure,
  fetchCustomerBookingsSuccess,
  fetchCustomerBookingsFailure,
  fetchTransitServiceTypeSuccess,
  fetchTransitServiceTypeFailure,
  fetchComplementaryBookingsSuccess,
  fetchComplementaryBookingsFailure,
  updateBookingDiscountApprovalStatusFailure,
  updateBookingDiscountApprovalStatusSuccess,
  insertInstantBookingSuccess,
  insertInstantBookingFailure,
  instantBookingTokenGeneratorSuccess,
  instantBookingTokenGeneratorFailure,
  fetchInstantBookingsFailure,
  fetchInstantBookingsSuccess,
  editBookingSuccess,
  editBookingFailure,
  getAllBookingsSuccess,
  getAllBookingsFailure
} from "./BookingAction";

import {
  FETCH_BOOKINGS_REQUEST,
  FETCH_BOOKING_REQUEST,
  ADD_BOOKING_REQUEST,
  DELETE_BOOKING_REQUEST,
  FETCH_SERVICE_TYPE_REQUEST,
  FETCH_ALL_BOOKINGS_REQUEST,
  FETCH_CUSTOMER_BOOKINGS_REQUEST,
  FETCH_TRANSIT_SERVICE_TYPE_REQUEST,
  FETCH_COMPLEMENTARY_BOOKINGS_REQUEST,
  UPDATE_BOOKING_DISCOUNT_APPROVAL_STATUS_REQUEST,
  INSERT_INSTANT_BOOKING_REQUEST,
  INSTANT_TOKEN_GENERATOR_REQUEST,
  FETCH_INSTANT_BOOKINGS_REQUEST,
  EDIT_BOOKING_REQUEST,
  GET_ALL_BOOKINGS_REQUEST
} from "./BookingType";

import axiosInstance from "../instance/AxiosInstance";

function* bookingViewSaga({ payload }) {
  try {
    const response = yield call(bookingViewEffect, payload);
    yield put(fetchBookingSuccess(response));
  } catch (error) {
    yield put(fetchBookingsSuccess([]));
    yield put(fetchBookingFailure(error || "Failed to Fetch Booking"));
  }
}

function* bookingViewAllSaga({ payload }) {
  try {
    const response = yield call(bookingViewAllEffect, payload);
    yield put(fetchBookingsSuccess(response));
  } catch (error) {
    yield put(fetchBookingsSuccess([]));
    yield put(fetchBookingsFailure(error || "Failed to Fetch Bookings"));
  }
}

function* fetchAllBookingsSaga(action) {
  const { booked_type } = action.payload;
  try {
    const response = yield call(fetchAllBookingsEffect, booked_type);
    yield put(getAllBookingsSuccess(response));
  } catch (error) {
    yield put(getAllBookingsSuccess([]));
    yield put(getAllBookingsFailure(error || "Failed to Fetch All Bookings"));
  }
}

function* fetchCustomerBookingsSaga(action) {
  const {
    customer_id,
    pageNo,
    pageSize,
    type,
    currentDate,
    vendor_id,
    booked_type
  } = action.payload;
  try {
    const response = yield call(
      fetchCustomerBookingsEffect,
      customer_id,
      pageNo,
      pageSize,
      type,
      currentDate,
      vendor_id,
      booked_type
    );
    yield put(fetchCustomerBookingsSuccess(response));
  } catch (error) {
    yield put(fetchCustomerBookingsFailure(error));
  }
}

function* bookingAddSaga({ payload }) {
  try {
    const response = yield call(bookingAddEffect, payload);
    yield put(addBookingSuccess(response));
  } catch (error) {
    yield put(addBookingFailure(error || "Failed to Add Booking"));
  }
}

function* InstantBookingAddSaga({ payload }) {
  try {
    const response = yield call(instantBookingAddEffect, payload);
    yield put(insertInstantBookingSuccess(response.message));
  } catch (error) {
    yield put(insertInstantBookingFailure(error || "Failed to Add Booking"));
  }
}

function* bookingEditSaga({ payload }) {
  try {
    const response = yield call(bookingEditEffect, payload);
    yield put(editBookingSuccess(response));
  } catch (error) {
    yield put(editBookingFailure(error || "Failed to Add Booking"));
  }
}

function* InstantBookingTokenSaga({ payload }) {
  try {
    const response = yield call(instantBookingTokenEffect, payload);
    yield put(instantBookingTokenGeneratorSuccess(response.token));
  } catch (error) {
    yield put(
      instantBookingTokenGeneratorFailure(error || "Failed to Add Booking")
    );
  }
}

function* bookingDeleteSaga(payload) {
  console.log("payload", payload);
  try {
    const response = yield call(bookingDeleteEffect, payload);

    yield put(deleteBookingSuccess(response.message));
  } catch (error) {
    yield put(deleteBookingFailure(error || "Failed to Delete Booking"));
  }
}

function* serviceGetTypeSaga({ payload }) {
  try {
    const response = yield call(fetchServiceTypeEffect, payload);

    yield put(fetchServiceTypeSuccess(response?.data?.data));
  } catch (error) {
    yield put(fetchServiceTypeFailure(error));
  }
}

function* transitServiceGetTypeSaga({ payload }) {
  console.log("FETCH_TRANSIT_SERVICE_TYPE_REQUEST");
  try {
    const response = yield call(fetchTransitServiceTypeEffect, payload);

    yield put(fetchTransitServiceTypeSuccess(response?.data?.data));
  } catch (error) {
    yield put(fetchTransitServiceTypeFailure(error));
  }
}

function* fetchComplementaryBookingsSaga(action) {
  try {
    const { pageNo, pagesize, approove_status, currentDate } = action.payload;
    const response = yield call(
      axiosInstance.get,
      `/bookservice/complementrybookingservice`,
      {
        params: {
          pagination_required: true,
          pageNo,
          pagesize,
          booked_type: 2,
          approove_status,
          currentDate
        }
      }
    );
    yield put(fetchComplementaryBookingsSuccess(response.data));
  } catch (error) {
    yield put(fetchComplementaryBookingsFailure(error.message));
  }
}

function* fetchInstantBookingsSaga(action) {
  try {
    const { pageNo, pagesize, type, currentDate } = action.payload;
    const response = yield call(axiosInstance.get, `/bookservice/list`, {
      params: {
        pagination_required: true,
        pageNo,
        pagesize,
        type,
        booked_type: 3,
        currentDate
      }
    });
    yield put(fetchInstantBookingsSuccess(response.data));
  } catch (error) {
    yield put(fetchInstantBookingsFailure(error.message));
  }
}

function* handleUpdateBookingDiscountApprovalStatus(action) {
  try {
    const response = yield call(updateBookingDiscountStatusAPI, action.payload);

    yield put(updateBookingDiscountApprovalStatusSuccess(response));
  } catch (error) {
    yield put(
      updateBookingDiscountApprovalStatusFailure(
        error.response?.data?.message || "Failed to update status"
      )
    );
  }
}

export default function* bookingSaga() {
  yield takeLatest(FETCH_BOOKINGS_REQUEST, bookingViewAllSaga);
  yield takeLatest(GET_ALL_BOOKINGS_REQUEST, fetchAllBookingsSaga);
  yield takeLatest(FETCH_BOOKING_REQUEST, bookingViewSaga);
  yield takeLatest(ADD_BOOKING_REQUEST, bookingAddSaga);
  yield takeLatest(DELETE_BOOKING_REQUEST, bookingDeleteSaga);
  yield takeLatest(FETCH_SERVICE_TYPE_REQUEST, serviceGetTypeSaga);
  yield takeLatest(FETCH_CUSTOMER_BOOKINGS_REQUEST, fetchCustomerBookingsSaga);
  yield takeLatest(INSERT_INSTANT_BOOKING_REQUEST, InstantBookingAddSaga);
  yield takeLatest(INSTANT_TOKEN_GENERATOR_REQUEST, InstantBookingTokenSaga);
  yield takeLatest(EDIT_BOOKING_REQUEST, bookingEditSaga);
  yield takeLatest(
    FETCH_TRANSIT_SERVICE_TYPE_REQUEST,
    transitServiceGetTypeSaga
  );
  yield takeLatest(
    FETCH_COMPLEMENTARY_BOOKINGS_REQUEST,
    fetchComplementaryBookingsSaga
  );
  yield takeLatest(
    UPDATE_BOOKING_DISCOUNT_APPROVAL_STATUS_REQUEST,
    handleUpdateBookingDiscountApprovalStatus
  );
  yield takeLatest(FETCH_INSTANT_BOOKINGS_REQUEST, fetchInstantBookingsSaga);
}
